var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.code === _vm.dictionaryKeys.userName
    ? _c("yxtbiz-user-name", { attrs: { name: _vm.name } })
    : _vm.code === _vm.dictionaryKeys.deptName
    ? _c("yxtbiz-dept-name", { attrs: { name: _vm.name } })
    : _c("span", [_vm._v(_vm._s(_vm.name))])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }